export default {"src":"/_next/static/media/forgotPassword-img.ec3f429e.svg","height":247,"width":466};